<template>
  <tr
    :class="[
      'tr-group ms-tr',
      dataRow.IsBold ? 'ms-format-bold' : '',
      dataRow.IsItalic ? 'ms-format-italic' : '',
    ]"
    v-if="!dataRow.isHide"
  >
    <td
      v-for="(col, index) in columnSumary"
      :key="index"
      :colspan="col.groupColspan"
      class="ms-td ms-col-td"
      :class="[index === columnSumary?.length - 1 ? 'ms-col-td-last' : '']"
    >
      <div class="flex-row" :class="`level-${dataRow.level}`">
        <div
          v-if="index === 0"
          class="pointer"
          :class="[dataRow.expanded ? 'expand' : 'collapse']"
          @click="toggle_click"
        ></div>
        <div
          :class="[
            `text-${col.align || 'left'}`,
            col.cssClass,
            'text-overflow',
            'content-cell text-overflow',
          ]"
        >
          <span
            :class="[`text-${col.align || 'left'}`]"
            :ref="`text-${col.dataField}`"
          >
            {{
              $ms.format.formatData(dataRow[col.dataField], {
                formatType: col.formatType,
                optionFormat: col.optionFormat,
                enumName: col.enum,
              })
            }}
          </span>
        </div>
      </div>
    </td>

    <td :key="100" v-if="$slots.widget" class="ms-td widget-item sticky">
      <slot name="widget" />
    </td>
  </tr>
</template>

<script>
import { computed, watch } from 'vue';
export default {
  props: {
    col: {
      default: () => [],
      type: Object,
    },
    columnSumary: {
      default: () => [],
      type: Array,
    },
    dataRow: {
      default: () => {},
      type: Object,
    },
  },
  emits: ['toogleTree'],
  setup(props, { emit }) {
    const toggle_click = () => {
      emit('toogleTree', props.dataRow);
    };

    return { toggle_click };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsTrViewer.scss';
.ms-format-bold {
  font-weight: $font-weight-bold;
}
.ms-format-italic {
  font-style: italic;
}

.tr-group {
  ::deep(.widget-container) {
    display: none;
  }
  .ms-td {
    padding-left: 2px !important;
  }
}

.pointer {
  height: 24px;
  width: 24px;
  position: relative;
  margin-right: 6px;
  &.expand {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -49px;
    }
  }

  &.collapse {
    &:before {
      content: '';
      background: transparent url($ms-image-sprites) no-repeat;

      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-position: -336px -121px;
    }
  }
}
.content-cell {
  line-height: 24px !important;
}
</style>
